<template>
    <div
        :class="{
            'dsh-control-define': true,
            'dsh-control-define-multiple': Array.isArray(val),
            'dsh-control-define-disabled': !canEdit
        }"
        @click="clickInput"
    >
        <!-- 有值 -->
        <template v-if="Array.isArray(val) ? !!val.length : !!val">
            <div v-if="Array.isArray(val)">
                <dsh-tags
                    :list="val"
                    @delete="deleteTag"
                    :propsObj="{ closable: canEdit }"
                ></dsh-tags>
            </div>

            <div
                v-else
                class="dsh-control-define-text"
            >
                <span class="dsh-ellipsis">{{ val }}</span>
                <Icon
                    v-if="canEdit"
                    type="md-close"
                    @click.stop="clickClear"
                />
            </div>
        </template>

        <!-- 无值 -->
        <span
            v-else
            class="dsh-control-define-nodata"
        >{{ this.propsObj._showPlaceholder === false ? "" : `请选择${propsObj._name}` }}</span>
    </div>
</template>

<script>
    export default {
        name: "DshControlDefine",
        props: {
            canEdit: {
                type: Boolean,
                default: true
            },
            value: {
                type: [String, Array],
                default () {
                    return [];
                }
            },
            propsObj: {
                type: Object,
                default () {
                    return {};
                }
            }
        },
        data () {
            return {};
        },
        computed: {
            val: {
                get () {
                    return this.value;
                },
                set (val) {
                    this.$emit("input", val);
                }
            }
        },
        created () {},
        methods: {
            clickInput (e) {
                if (!this.canEdit) {
                    e.stopPropagation();
                }
            },

            // 删除
            deleteTag (item, index, ...params) {
                this.val = [...this.val];

                this.$emit("delete", item, index, ...params);
            },
            // 清除文字
            clickClear () {
                this.val = "";

                this.$emit("delete");
            }
        }
    };
</script>



// WEBPACK FOOTER //
// node_modules/bri-vtools/src/components/small/DshControlDefine.vue